import React from 'react';
import { Modal,Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const MicroSceneBubble = ({ scene, onClick }) => (
  <div className="ms-bubble" onClick={() => onClick(scene)}>
    {scene.id}
  </div>
);

export const MicroSceneBubbleList = ({ bubbles, onBubbleClick }) => (
  <div className="ms-bubble-list">
    {bubbles.map((bubble) => (
      <MicroSceneBubble 
        key={bubble.id} 
        scene={bubble} 
        onClick={onBubbleClick}
      />
    ))}
  </div>
);
export const MicroSceneDetailModal = ({ isOpen, onClose, scene }) => {
    if (!isOpen || !scene) return null; // 如果modal未打开或scene为null，不渲染任何内容
  
    return (
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="micro-scene-modal-title"
      >
        <Box className="ms-modal-content">
          <h2 id="micro-scene-modal-title">{scene.title}</h2>
          <div className="ms-scene-info">
            <h3>关键指标:</h3>
            <div className="ms-key-indicators">
              {scene.indicators && scene.indicators.map((indicator, index) => (
                <span key={index} className="ms-indicator">{indicator}</span>
              ))}
            </div>
            <p><strong>数据支持：</strong> {scene.dataSupport || '暂无数据'}</p>
            <p><strong>行为与能力刻画：</strong> {scene.behaviorAndAbility || '暂无数据'}</p>
            <p><strong>优势：</strong> {scene.strengths || '暂无数据'}</p>
            <p><strong>改进领域：</strong> {scene.areasForImprovement || '暂无数据'}</p>
            <p><strong>映射到工程能力要求：</strong> {scene.mappingToEngineering || '暂无数据'}</p>
            <p><strong>置信度：</strong> {scene.confidenceLevel || '暂无数据'}</p>
          </div>
        </Box>
      </Modal>
    );
  };